import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import NewPromotion from './NewPromotion';

import Box from '../ui/Box';

//providers
import DataService from '../../services/DataService'; var ds = DataService;

export default class PromotionsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      all_food: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      isDemoLogin: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 7;
  componentDidMount() {
    this.getAllPromos(this.state.current_offset);
    window.addEventListener('updatePromoTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });

    const userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };
  }

  onChangePage(e) {
    this.getAllPromos(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    });
  }

  getAllPromos(offset, offset_change = 0) {
    ds.getPromotions(this.maxItems, offset,
      data => {
        this.setState({
          all_food: data.docs,
          totalCount: data.count
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {}
    )
  }

  refreshTable(e) {
    this.getAllPromos(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
    if (refresh) {
      this.getAllPromos(0);
    }

  }

  editPromotion(row, e) {
    row.isEdit = true;
    this.setState({
      dialog: {
        open: true,
        body: <NewPromotion details={row} unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    })
  }

  deletePromo(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete Promotion permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeletePromo({ _id: row._id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getAllPromos(x > 0 ? x : 0, 1);
                }, err => {}
              );
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    });
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Promotion List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Title">Title</TableHeaderColumn>
                <TableHeaderColumn tooltip="Description">Description</TableHeaderColumn>
                <TableHeaderColumn tooltip="Type">Type</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_food.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{row.title}</TableRowColumn>
                    <TableRowColumn 
                      style={{
                        whiteSpace: 'pre-line', 
                        paddingRight: '30px', 
                        paddingTop: '7px',
                        paddingBottom: '7px'
                      }}
                    >
                      {row.messge}
                    </TableRowColumn>
                    <TableRowColumn>{row.tag}</TableRowColumn>

                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editPromotion.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      {
                        this.state.isDemoLogin === false ?
                          <i className="material-icons warn-fg"
                            style={{cursor:'pointer'}}
                            onClick={this.deletePromo.bind(this, row)}
                          >
                            delete
                          </i>
                        : null
                      }
                    </TableRowColumn>

                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableRowColumn colSpan="4" style={{ textAlign: 'center' }}></TableRowColumn>
                <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>{pagination}</TableRowColumn>
              </TableRow>
            </TableFooter>

          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/promotions/PromotionsList.js